var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Position/Fret/Content/NoteContent/index.js";
import React from 'react';
import pt from 'prop-types';
import { Note } from 'tonal';
import AccWrapper from './AccWrapper';

const letterElement = (letter, note) => /*#__PURE__*/React.createElement("span", {
  key: `letter-${note}`,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 3
  }
}, letter);

const formatAcc = acc => acc.replace('#', '\u266F').replace('b', '\u266D');

const accElement = (acc, note) => /*#__PURE__*/React.createElement(AccWrapper, {
  key: `acc-${note}`,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 3
  }
}, formatAcc(acc));

const octElement = (oct, note) => /*#__PURE__*/React.createElement("span", {
  key: `oct-${note}`,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 19,
    columnNumber: 3
  }
}, oct);

const formatNote = (note, noteType) => {
  const tokens = Note.tokenize(note);
  return tokens.map((token, i) => {
    if (i === 0) return letterElement(token, note);
    if (i === 1 && token) return accElement(token, note);
    if (i === 2 && noteType === 'pitch') return octElement(token, note);
    return null;
  });
};

const formatEnharmonics = (note, enharmonic, noteType) => [...formatNote(note, noteType), /*#__PURE__*/React.createElement("span", {
  key: "divider",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 34,
    columnNumber: 5
  }
}, "/"), ...formatNote(enharmonic, noteType)];

const NoteContent = ({
  note,
  noteType,
  showEnharmonics
}) => {
  const enharmonic = Note.enharmonic(note);
  const hasEnharmonic = note !== enharmonic;
  const contentNote = hasEnharmonic && showEnharmonics ? formatEnharmonics(note, enharmonic, noteType) : formatNote(note, noteType);
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, contentNote);
};

NoteContent.propTypes = {
  note: pt.string.isRequired,
  noteType: pt.string.isRequired,
  showEnharmonics: pt.bool.isRequired
};
export default NoteContent;
